import React from 'react';
import { useGetOGPUserInfo } from 'ogp/hooks';
import {
  isOgpRouteAllowedForLimitedCompany,
  limitedCompanyDefaultFallbackPath,
  useOgpCompanyTypeContext,
} from 'ogp/limited-company-capabilities';
import { routePrefix as ogpPrefix } from 'ogp/settings';
import { generatePath, Navigate } from 'react-router-dom';
import { LimitedCompanyRouteGuardProps } from './limited-company-route-guard.types';
import { useLimitedCompanyRouteNotAvailableAlert } from './use-limited-company-route-not-available-alert';
import { useOgpPathWithinCompany } from './use-ogp-path-within-company';

export const LimitedCompanyRouteGuard = ({
  routePath,
  children,
}: LimitedCompanyRouteGuardProps) => {
  const userQuery = useGetOGPUserInfo();
  const pathWithinCompany = useOgpPathWithinCompany();

  const { isLimitedCompany: isLimited } = useOgpCompanyTypeContext();
  const isAllowed = !isLimited || isOgpRouteAllowedForLimitedCompany(pathWithinCompany);

  useLimitedCompanyRouteNotAvailableAlert(isLimited, isAllowed);

  if (isAllowed) {
    return <>{children}</>;
  }

  const redirectPath = generatePath(
    `${ogpPrefix}/:companyHash/${limitedCompanyDefaultFallbackPath}`,
    {
      companyHash: userQuery.data?.userInfo.company.slug ?? '',
    }
  );

  return <Navigate to={redirectPath} replace state={{ blockedRoute: routePath }} />;
};
